let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3ZTIv")).then(() => parcelRequire('9tE8O'));